import { Component } from '@angular/core';

@Component({
    selector: 'app-approvals',
    templateUrl: './approvals.component.html',
    standalone: false
})
export class ApprovalsComponent {



}
